import { useContext } from "react";
import { PanelContext } from "../context/PanelContext";

import TitleText from "./TitleText";
import SmallCaps from "./SmallCaps";
import NavBarCom from "./NavBarCom";
import Logo from "../assets/Logo.svg";

/* 
  lg: navbar
  md: navbar 
  default (sm): hamburger-navbar
*/

type Props = {
  showLeftNavbar: Boolean;
  setShowLeftNavbar: Function;
};

export default function LeftNavbar(props: Props) {
  const panelContext = useContext(PanelContext);

  return (
    <>
      <div
        className={`${
          props.showLeftNavbar ? "hidden" : "inline-flex"
        } lg:hidden md:hidden px-5 py-2 bg-navbar-green relative`}
      >
        <div className="flex items-center gap-x-3">
          <img src={Logo} alt="logo" className="w-8 h-8" />
          <span className="font-bold">FocusFlow</span>
        </div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-7 h-7 absolute right-4"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
            onClick={() => props.setShowLeftNavbar(true)}
          />
        </svg>
      </div>
      <div
        className={`${
          props.showLeftNavbar ? "" : "hidden"
        } lg:block lg:w-[20rem] md:block md:min-w-fit min-h-max h-screen bg-navbar-green relative`}
      >
        <div className="px-10 py-8">
          <div className="flex items-center gap-x-3">
            <img src={Logo} alt="logo" className="w-8 h-8" />
            <span className="font-bold">FocusFlow</span>
          </div>

          <div className="mt-6">
            <NavBarCom text="Home" locate="/">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
                />
              </svg>
            </NavBarCom>
          </div>

          <div className="mt-2">
            <SmallCaps text="Quickstart" />
            <div
              onClick={() => {
                panelContext.showCreateTaskPanel
                  ? panelContext.closeCreateTaskPanel()
                  : panelContext.openCreateTaskPanel();
                props.setShowLeftNavbar(false);
              }}
              className="flex justify-left items-center gap-x-3 -ms-4 ps-4 h-9 no-underline text-black"
              style={{
                backgroundColor: panelContext.showCreateTaskPanel
                  ? "white"
                  : "",
                borderRadius: panelContext.showCreateTaskPanel ? "5px" : "",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <TitleText text="Create Task" />
            </div>
            <div
              onClick={() => {
                panelContext.showCreateEventPanel
                  ? panelContext.closeCreateEventPanel()
                  : panelContext.openCreateEventPanel();
                props.setShowLeftNavbar(false);
              }}
              className="flex justify-left items-center gap-x-3 -ms-4 ps-4 h-9 no-underline text-black"
              style={{
                backgroundColor: panelContext.showCreateEventPanel
                  ? "white"
                  : "",
                borderRadius: panelContext.showCreateEventPanel ? "5px" : "",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5m-9-6h.008v.008H12v-.008zM12 15h.008v.008H12V15zm0 2.25h.008v.008H12v-.008zM9.75 15h.008v.008H9.75V15zm0 2.25h.008v.008H9.75v-.008zM7.5 15h.008v.008H7.5V15zm0 2.25h.008v.008H7.5v-.008zm6.75-4.5h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V15zm0 2.25h.008v.008h-.008v-.008zm2.25-4.5h.008v.008H16.5v-.008zm0 2.25h.008v.008H16.5V15z"
                />
              </svg>
              <TitleText text="Create Event" />
            </div>
            <div
              onClick={() => {
                panelContext.showSessionPanel
                  ? panelContext.closeSessionPanel()
                  : panelContext.openSessionPanel();
                props.setShowLeftNavbar(false);
              }}
              className="flex justify-left items-center gap-x-3 -ms-4 ps-4 h-9 no-underline text-black"
              style={{
                backgroundColor: panelContext.showSessionPanel ? "white" : "",
                borderRadius: panelContext.showSessionPanel ? "5px" : "",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="w-6 h-6"
              >
                <path
                  fillRule="evenodd"
                  d="M4.5 5.653c0-1.426 1.529-2.33 2.779-1.643l11.54 6.348c1.295.712 1.295 2.573 0 3.285L7.28 19.991c-1.25.687-2.779-.217-2.779-1.643V5.653z"
                  clipRule="evenodd"
                />
              </svg>
              <TitleText text="Start Session" />
            </div>
            <div
              onClick={() => {
                panelContext.showCreateJEntryPanel
                  ? panelContext.closeCreateJEntryPanel()
                  : panelContext.openCreateJEntryPanel();
                props.setShowLeftNavbar(false);
              }}
              className="flex justify-left items-center gap-x-3 -ms-4 ps-4 h-9 no-underline text-black"
              style={{
                backgroundColor: panelContext.showCreateJEntryPanel
                  ? "white"
                  : "",
                borderRadius: panelContext.showCreateJEntryPanel ? "5px" : "",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
                />
              </svg>
              <TitleText text="Create Journal Entry" />
            </div>
          </div>

          <div className="mt-4">
            <SmallCaps text="View" />

            <NavBarCom
              text="Photos of the Month"
              locate="/photosofthemonth"
              onClick={() => {
                props.setShowLeftNavbar(false);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-5 h-5"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
                />
              </svg>
            </NavBarCom>
            <NavBarCom
              text="Daily Achievements"
              locate="/dailyachievements"
              onClick={() => {
                props.setShowLeftNavbar(false);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-5 h-5"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M16.5 18.75h-9m9 0a3 3 0 013 3h-15a3 3 0 013-3m9 0v-3.375c0-.621-.503-1.125-1.125-1.125h-.871M7.5 18.75v-3.375c0-.621.504-1.125 1.125-1.125h.872m5.007 0H9.497m5.007 0a7.454 7.454 0 01-.982-3.172M9.497 14.25a7.454 7.454 0 00.981-3.172M5.25 4.236c-.982.143-1.954.317-2.916.52A6.003 6.003 0 007.73 9.728M5.25 4.236V4.5c0 2.108.966 3.99 2.48 5.228M5.25 4.236V2.721C7.456 2.41 9.71 2.25 12 2.25c2.291 0 4.545.16 6.75.47v1.516M7.73 9.728a6.726 6.726 0 002.748 1.35m8.272-6.842V4.5c0 2.108-.966 3.99-2.48 5.228m2.48-5.492a46.32 46.32 0 012.916.52 6.003 6.003 0 01-5.395 4.972m0 0a6.726 6.726 0 01-2.749 1.35m0 0a6.772 6.772 0 01-3.044 0"
                />
              </svg>
            </NavBarCom>
            <NavBarCom
              text="Goal Roadmaps"
              locate="/goalroadmaps"
              onClick={() => {
                props.setShowLeftNavbar(false);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-5 h-5"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M3 3v1.5M3 21v-6m0 0l2.77-.693a9 9 0 016.208.682l.108.054a9 9 0 006.086.71l3.114-.732a48.524 48.524 0 01-.005-10.499l-3.11.732a9 9 0 01-6.085-.711l-.108-.054a9 9 0 00-6.208-.682L3 4.5M3 15V4.5"
                />
              </svg>
            </NavBarCom>
          </div>

          <div className="absolute bottom-8">
            <NavBarCom
              text="Settings"
              locate="/settings"
              onClick={() => {
                props.setShowLeftNavbar(false);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="w-6 h-6"
              >
                <path
                  fillRule="evenodd"
                  d="M11.078 2.25c-.917 0-1.699.663-1.85 1.567L9.05 4.889c-.02.12-.115.26-.297.348a7.493 7.493 0 00-.986.57c-.166.115-.334.126-.45.083L6.3 5.508a1.875 1.875 0 00-2.282.819l-.922 1.597a1.875 1.875 0 00.432 2.385l.84.692c.095.078.17.229.154.43a7.598 7.598 0 000 1.139c.015.2-.059.352-.153.43l-.841.692a1.875 1.875 0 00-.432 2.385l.922 1.597a1.875 1.875 0 002.282.818l1.019-.382c.115-.043.283-.031.45.082.312.214.641.405.985.57.182.088.277.228.297.35l.178 1.071c.151.904.933 1.567 1.85 1.567h1.844c.916 0 1.699-.663 1.85-1.567l.178-1.072c.02-.12.114-.26.297-.349.344-.165.673-.356.985-.57.167-.114.335-.125.45-.082l1.02.382a1.875 1.875 0 002.28-.819l.923-1.597a1.875 1.875 0 00-.432-2.385l-.84-.692c-.095-.078-.17-.229-.154-.43a7.614 7.614 0 000-1.139c-.016-.2.059-.352.153-.43l.84-.692c.708-.582.891-1.59.433-2.385l-.922-1.597a1.875 1.875 0 00-2.282-.818l-1.02.382c-.114.043-.282.031-.449-.083a7.49 7.49 0 00-.985-.57c-.183-.087-.277-.227-.297-.348l-.179-1.072a1.875 1.875 0 00-1.85-1.567h-1.843zM12 15.75a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5z"
                  clipRule="evenodd"
                />
              </svg>
            </NavBarCom>
            <div className="flex justify-left items-center gap-x-3 -ms-4 ps-4 h-9 no-underline text-black">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="w-6 h-6"
              >
                <path
                  fillRule="evenodd"
                  d="M7.5 3.75A1.5 1.5 0 006 5.25v13.5a1.5 1.5 0 001.5 1.5h6a1.5 1.5 0 001.5-1.5V15a.75.75 0 011.5 0v3.75a3 3 0 01-3 3h-6a3 3 0 01-3-3V5.25a3 3 0 013-3h6a3 3 0 013 3V9A.75.75 0 0115 9V5.25a1.5 1.5 0 00-1.5-1.5h-6zm5.03 4.72a.75.75 0 010 1.06l-1.72 1.72h10.94a.75.75 0 010 1.5H10.81l1.72 1.72a.75.75 0 11-1.06 1.06l-3-3a.75.75 0 010-1.06l3-3a.75.75 0 011.06 0z"
                  clipRule="evenodd"
                />
              </svg>
              <TitleText text="Logout" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
